<template>
  <z-dialogo
    ref="dialogo"
    titulo="Componentes"
    scrollable
    dividers
    no-padding
    largura="500px"
    altura="383px"
    @abrir="onAbrir"
  >

    <template v-slot:prepend>
      <v-toolbar flat color="white">
        <v-text-field
          ref="busca"
          v-model="busca"
          rounded
          filled
          outlined
          single-line
          dense
          label="Pesquisar"
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          @keydown.enter="onBuscarPressEnter"
          @focus="onBuscaFocus"
          @blur="is_busca_focused = false"
          @click:clear="limparBusca"
        ></v-text-field>
        <!-- <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn small fab color="primary" class="ml-3 mr-1" v-on="on" @click="adicionar">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Adicionar Componente</span>
        </v-tooltip> -->
      </v-toolbar>
    </template>

    <template v-slot:texto>
      <div ref="topo"></div>
      <z-loading :loading="carregando">

        <v-data-table
          mobile-breakpoint="0"
          disable-pagination
          disable-sort
          hide-default-footer
          :headers="headers"
          :items="itens_busca"
          :loading="carregando"
          fixed-header_
          height_="383px"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr 
                v-for="(item, index) in items" 
                ref="urls" 
                class="apontador noselect" 
                :key="index" 
                :class="{'active': isActive(index)}" 
                @click="selecionar(item)" 
              >
                <td>{{ item.nome }}</td>
              </tr>
            </tbody>
          </template>

        </v-data-table>

      </z-loading>
    </template>

    <template v-slot:actions_left>
      <span class="text-subtitle-2">Componentes encontrados: {{ itens_busca.length }}</span>
    </template>
    <template v-slot:actions_right>
      <v-btn color="primary" @click="fechar()">Fechar</v-btn>
    </template>

  </z-dialogo>
</template>

<script>

import parceirosApi from "@/app/services/parceirosApi";
import { abrirJanela } from "@/app/helpers/utils";

import buscas_mixin from "@/app/mixins/buscas";

  export default {
    name: 'DialogoBuscarParceiros',

    mixins: [buscas_mixin],

    data() {
      return {
        headers: [
          { text: "Parceiro", value: "nome" },
        ],
      };
    },

    methods: {

      onAbrir() {
        console.log('Abrir');
      },

      async buscar() {
        try {
          // if (this.busca && this.busca.length > 0) {
            this.carregando = true;
            this.itens_busca = await parceirosApi.buscar(this.busca);
            this.atual = 0;
            setTimeout(() => {
              this.scrollList();
            }, 100);
          // }
        } catch (error) {
          this.$eventbus.notificarErro('Não foi possível efetuar a busca.');
        } finally {
          this.carregando = false;
        }
      },
      
      adicionar() {
        abrirJanela(window.location.origin + '/#/cadastros/pecas/adicionar');
      }
    },
  }
</script>

<style scoped>

</style>